import "@/App.css";
import QuizApp from "./QuizApp.jsx";

function App() {
  return <QuizApp />;
}

export default App;
